import React from "react";
import "../styles/FailurePopup.css";

const FailurePopup = ({ message, onClose }) => {
  return (
    <div className="popup-overlay1" onClick={onClose}>
      <div className="popup-box1 failure-box1" onClick={(e) => e.stopPropagation()}>
        <h3>Submission Failed!</h3>
        <p>{message}</p>
        <button className="popup-btn1 failure-btn1" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default FailurePopup;
